var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 30,
    viewBox: "0 0 35 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M3.16602 15C3.16602 10.2863 3.16602 7.92877 4.81268 6.46502C6.45793 5.00002 9.10776 5.00002 14.406 5.00002H20.026C25.3243 5.00002 27.9741 5.00002 29.6194 6.46502C31.266 7.92877 31.266 10.2863 31.266 15C31.266 19.7138 31.266 22.0713 29.6194 23.535C27.9741 25 25.3243 25 20.026 25H14.406C9.10776 25 6.45793 25 4.81268 23.535C3.16602 22.0713 3.16602 19.7138 3.16602 15Z",
    stroke: "#BDBDBD",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.216 12.5V17.5M14.7826 13.75L19.6495 16.25M19.6495 13.75L14.7812 16.25M9.8145 12.5V17.5M7.38104 13.75L12.248 16.25M12.248 13.75L7.38104 16.25M24.6176 12.5V17.5M22.1841 13.75L27.051 16.25M27.051 13.75L22.1827 16.25",
    stroke: "#BDBDBD",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordIcon);
export default __webpack_public_path__ + "static/media/password_icon.f14463c44369d967cbad0d1f559a382b.svg";
export { ForwardRef as ReactComponent };